import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { CampaignFormValues } from 'src/models/Campaign.model';
import useCampaignGroup from 'src/hooks/useCampaignGroup';
import ATMSelectValue from 'src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue';

type Props = {
    formikProps: FormikProps<CampaignFormValues>;
    onClose: () => void;
    formType?: string
};


const CampaignForm = ({ formikProps, onClose, formType }: Props) => {

    const { CampaignGroup, isDataLoading } = useCampaignGroup();
    const campaignGroupOptions = CampaignGroup?.map((campaign) => {
        return {
            label: campaign?.campaignGroupName,
            value: campaign?._id,
        };
    });
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>  {formType} Campaign </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                {/* Campaign */}
                <div>
                    <ATMTextField
                        name='campaignName'
                        value={values.campaignName}
                        onChange={(e) => {
                            setFieldValue('campaignName', e.target.value);
                        }}
                        placeholder='campaign name'
                        label='Campaign Name'
                        onBlur={handleBlur}
                    />
                </div>
                {/*Select Campaign */}
                <ATMSelectValue
                    name="campaignGroupId"
                    value={values?.campaignGroupId}
                    onChange={(value) => setFieldValue("campaignGroupId", value)}
                    options={campaignGroupOptions}
                    label="Select Campaign Group"
                    isLoading={isDataLoading}
                />
              
            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default CampaignForm;